'use es6';

import PropTypes from 'prop-types';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const PerformanceWell = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexGrow: "1",
    justifyContent: "between",
    flexDirection: "row",
    alignItems: "stretch",
    maxBlockSize: "100%",
    minBlockSize: "0",
    children: children
  });
};
PerformanceWell.propTypes = {
  children: PropTypes.node.isRequired
};
export default PerformanceWell;